import MuiChip, { ChipProps as MuiChipProps } from "@mui/material/Chip";
import ClearIcon from "@mui/icons-material/Clear";
import React, { FunctionComponent, useCallback, useState } from "react";
import { useLocale } from "designSystem/locale";
import Tooltip from "../tooltip/Tooltip";

interface ChipProps extends MuiChipProps {
	/** localization resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name") */
	res?: string;

	/** parameters to pass if looking up resource */
	resParams?: Array<number | string>;
}

const Chip: FunctionComponent<ChipProps> = (props) => {
	const [overflows, setOverflows] = useState(false);
	const { label, res, resParams, variant, ...otherProps } = props;

	// icons for the pill
	const clearIcon = <ClearIcon />;

	const chipRef = useCallback((node: HTMLElement) => {
		if (node) {
			// if icon configured, the first element would be an icon
			const textNode = (props.icon ? node.childNodes[1] : node.childNodes[0]) as HTMLElement;
			setOverflows(textNode.scrollWidth > textNode.clientWidth);
		}
	}, [label, res]);

	const text = res ? useLocale()
		.resource(res, resParams) : "";
	const finalText = text || label;

	return (
		<Tooltip
			disableHoverListener={!overflows}
			title={finalText}
		>
			<MuiChip
				deleteIcon={clearIcon}
				label={finalText}
				ref={chipRef}
				variant={variant}
				{...otherProps}
			/>
		</Tooltip>
	);
};

export default Chip;